export function buildUrl(route: string, ...params: (string | number)[]) {
  return `${route}/${params.join('/')}`
}
